import { Injectable, Inject } from '@angular/core';

export class AgentDO {
	public id: Number;

	public guid:any;

	public agentNum: String = null;

	public clientId: Number;

	public userId: String = null;

	public channelCd: String = null;

	public statusCd: String = null;

	public subChannelCd: String = null;

	public designationCd: String = null;

	public licenseNum: String = null;

	public licenseExpiryDt: Date = null;

	public licenseIssueDt: Date = null;

	public categoryCd: String = null;

	public partnerCd: String = null;

	public partnerbranchCd: String = null;

	public partnerEmployeeNum: String = null;

	public clientRefGuid: String = null;

	public companyCd: any = null

	public companyBranchCd: any = null

	public companyContactUserId: any = null

	public divisionCd: any = null

	public subDivisionCd: any = null

	public vatApplicableFl: any = null

	public managerUserId: any = null

	public agentAdditionalFieldDOs: any = []

	


	public getId(): Number {
		return this.id;
	}

	public setId(id: Number): void {
		this.id = id;
	}

	public getAgentNum(): String {
		return this.agentNum;
	}

	public setAgentNum(agentNum: String) {
		this.agentNum = agentNum;
	}

	public getClientId(): Number {
		return this.clientId;
	}

	public setClientId(clientId: Number) {
		this.clientId = clientId;
	}

	public getUserId(): String {
		return this.userId;
	}

	public setUserId(userId: String) {
		this.userId = userId;
	}

	public getChannelCd(): String {
		return this.channelCd;
	}

	public setChannelCd(channelCd: String) {
		this.channelCd = channelCd;
	}

	public getStatusCd(): String {
		return this.statusCd;
	}

	public setStatusCd(statusCd: String) {
		this.statusCd = statusCd;
	}

	public getSubChannelCd(): String {
		return this.subChannelCd;
	}

	public setSubChannelCd(subChannelCd: String) {
		this.subChannelCd = subChannelCd;
	}

	public getDesignationCd(): String {
		return this.designationCd;
	}

	public setDesignationCd(designationCd: String) {
		designationCd = designationCd;
	}

	public getLicenseNum(): String {
		return this.licenseNum;
	}

	public setLicenseNum(licenseNum: String) {
		this.licenseNum = licenseNum;
	}

	public getLicenseExpiryDt(): Date {
		return this.licenseExpiryDt;
	}

	public setLicenseExpiryDt(licenseExpiryDt: Date) {
		this.licenseExpiryDt = licenseExpiryDt;
	}

	public getLicenseIssueDt(): Date {
		return this.licenseIssueDt;
	}

	public setLicenseIssueDt(licenseIssueDt: Date) {
		this.licenseIssueDt = licenseIssueDt;
	}

	public getCategoryCd(): String {
		return this.categoryCd;
	}

	public setCategoryCd(categoryCd: String) {
		this.categoryCd = categoryCd;
	}

	public getPartnerCd(): String {
		return this.partnerCd;
	}

	public setPartnerCd(partnerCd: String) {
		this.partnerCd = partnerCd;
	}

	public getPartnerbranchCd(): String {
		return this.partnerbranchCd;
	}

	public setPartnerbranchCd(partnerbranchCd: String) {
		this.partnerbranchCd = partnerbranchCd;
	}

	public getClientRefGuid(): String {
		return this.clientRefGuid;
	}

	public setClientRefGuid(clientRefGuid: String) {
		this.clientRefGuid = clientRefGuid;
	}
	// public getObjectName():String {
	// 	return AgentDO.class.getSimpleName();
	// }
}
